import alegartaTile from '../images/alegarta-tile.png';

const loadImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('The smoke background artwork could not be loaded.'));
    image.src = url;
  });

export async function getEmbeddedGiftCardSmokeBackground() {
  return loadImage(alegartaTile).then((image) => {
        const size = 720;
        const source = document.createElement('canvas');
        source.width = size;
        source.height = size;
        const sourceContext = source.getContext('2d', { willReadFrequently: true });
        if (!sourceContext) throw new Error('The browser cannot prepare print artwork.');
        sourceContext.drawImage(image, 0, 0, size, size);
        const pixels = sourceContext.getImageData(0, 0, size, size);
        for (let index = 0; index < pixels.data.length; index += 4) {
          const luminance =
            pixels.data[index] * 0.2126 +
            pixels.data[index + 1] * 0.7152 +
            pixels.data[index + 2] * 0.0722;
          const lineStrength = Math.max(0, Math.min(1, (luminance - 28) / 190));
          const shade = Math.round(255 - lineStrength * 24);
          pixels.data[index] = shade;
          pixels.data[index + 1] = shade;
          pixels.data[index + 2] = Math.min(255, shade + 1);
          pixels.data[index + 3] = 255;
        }
        sourceContext.putImageData(pixels, 0, 0);
        const dataUrl = source.toDataURL('image/png');
        if (!dataUrl.startsWith('data:image/png;base64,')) {
          throw new Error('The smoke background could not be embedded for printing.');
        }
        return dataUrl;
      });
}

export async function buildEmbeddedGiftCardHtml(buildHtml, cards, options = {}) {
  const smokeBackgroundUrl = await getEmbeddedGiftCardSmokeBackground();
  const html = buildHtml(cards, {
    ...options,
    smokeBackgroundUrl,
    rotateForTray: options.rotateForTray === true,
  });
  if (!html.includes('data:image/png;base64,')) {
    throw new Error('A6 print preflight failed because the smoke background is missing.');
  }
  return html;
}
